import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useNavbarContext } from '../../contexts/NavbarProvider.js';
import 'react';
import '@cheetahdigital/console-kit-cx';
import '../../node_modules/classnames/index.js';
import Tooltip from '../../shared/components/Tooltip/index.js';
import 'react-dom';
import Headline from '../../shared/elements/Headline/index.js';
import AppIconImage from '../AppSwitcher/AppIconImage.js';
import styles from './index.module.scss.js';

var AppLogo = function (_a) {
    var alt = _a.alt, _b = _a.platformId, platformId = _b === void 0 ? "CES" : _b, appName = _a.appName, customAppName = _a.customAppName, customAppIcon = _a.customAppIcon, customAppTooltip = _a.customAppTooltip, appIcon = _a.appIcon, _c = _a.href, href = _c === void 0 ? "/" : _c;
    var authUiBaseUrl = useNavbarContext().authUiBaseUrl;
    return (jsx(Tooltip, __assign({ content: customAppTooltip, position: "bottom center", isGapless: true }, { children: jsxs("a", __assign({ className: styles.logo, href: href, rel: "noreferrer" }, { children: [(appIcon || customAppIcon) && (jsx(AppIconImage, { alt: alt, platformId: platformId, customAppIcon: customAppIcon, assetEndpoint: authUiBaseUrl, appIcon: appIcon }, void 0)), jsx(Headline, __assign({ weight: "light", size: "large" }, { children: jsx("span", { children: customAppName || appName }, void 0) }), void 0)] }), void 0) }), void 0));
};

export { AppLogo as default };
